var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCropsGrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6723 31.9717C23.7883 29.0085 25.8786 25.5236 29.8902 22.2013C29.8274 9.92503 22.6723 0 22.6723 0C22.6723 0 15.5156 9.92341 15.4512 22.1997C19.5191 25.5654 21.5853 29.0778 22.6723 31.9717Z",
    fill: "#D4C34E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0664 20.9774C31.2111 22.839 23.6196 27.6348 22.671 38.204C21.7209 29.0762 16.0297 23.7988 11.2757 20.9774C11.2757 20.9774 9.9616 28.2903 13.0713 34.8463C16.181 41.4039 22.5325 45 22.5325 45H22.8095C22.8095 45 29.1643 41.4039 32.2724 34.8463C35.3821 28.2903 34.0664 20.9774 34.0664 20.9774Z",
    fill: "#D4C34E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsGrain);
export default __webpack_public_path__ + "static/media/ic-crops-grain.7f3fdb22ec2671945bde7c7532baaa52.svg";
export { ForwardRef as ReactComponent };